import { render, staticRenderFns } from "./ComposicaoPedido.vue?vue&type=template&id=a7dfa47a&scoped=true"
import script from "./ComposicaoPedido.vue?vue&type=script&lang=js"
export * from "./ComposicaoPedido.vue?vue&type=script&lang=js"
import style0 from "./ComposicaoPedido.vue?vue&type=style&index=0&id=a7dfa47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dfa47a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSelect,VSimpleTable,VTextField})
